<template>
        <div class='relative'>
            <span class='iconIpt ilbk absolute'>
                <img src="../../assets/imgs/phone.png" alt="">
            </span>
            <input @blur="scrollInto" class='inputStyle' v-model='phone' type="text" name="" :placeholder=placeholder />
        </div>
</template>
<script>
    import {phoneReg} from '@/utils/regular.js'
export default {
    data(){
        return {
           phone:'',
        }
    },
    props: {
        verify:{ // 是否验证失败
            type: Boolean,
            default() { return false; }
        },
        placeholder:{ // placeholder 文字
            type: String,
            default() { return ''; }
        },
    },
    watch:{
        phone(val){
            val = val.trim();
            let phoneFlag;
            phoneFlag = phoneReg.test(val)
            this.$emit('phoneEmit',{
                name:val,
                phoneFlag:phoneFlag
            })

            this.bus.$emit("telPhoneCode",{
                name:val,
                phoneFlag:phoneFlag
            });
        },
        verify(val){
            this.verify = val
        }
    },
    methods:{
        cleanInfo(){
            this.applicantName = '' 
        },
        scrollInto(){
            window.setTimeout(function () {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
                if(scrollHeight){
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }
            }, 0);            
        }
    }
}
</script>
<style lang="less" scoped>
</style>